<div id="wrapper">

  <div style="background-image: url('/assets/navbarbackground.png')">
    <nav *ngIf="!router.url.includes('/admin')" class="navbar navbar-expand-lg navbar-dark">
      <a class="navbar-brand">
        <img (click)="navigateOrRefresh()" class="logo" src="/assets/lebtivitylogo.png" alt="">
      </a>
      <a href="/recycling" target="_blank"><i style="color: #77bb00;" class="fa fa-recycle fa-2x"></i></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item my-2 my-lg-0">
          </li>
        </ul>

        <form class="form-inline my-2 my-lg-0" [formGroup]='webSearchForm'>
          <!-- <input class="form-control mr-sm-2 topbarsearch" type="search" placeholder="Search Lebtivity"
          aria-label="Search" formControlName='name'>
        <button class="btn" type="submit" (click)="webSearchEvents()">
          <span style="color: white;" class="material-icons topbarsearch">
            search
          </span>
        </button> -->
          <!-- <input ngx-google-places-autocomplete #placesRef="ngx-places" class="form-control mr-sm-2 topbarsearch" type="search" placeholder="Search Address" aria-label="Search" formControlName='location'> -->
          <!-- TODO NEED TO IMPLEMENT RESET SEARCH HERE ?! -->
          <button *ngIf="search" (click)="defaultSearch()">x</button>
          <input class="searchinput" type="text" placeholder="Search Lebtivity" name="search" formControlName="name">
          <button class="searchinputbutton" type="submit"><i class="fa fa-search"
              (click)="webSearchEvents()"></i></button>
        </form>
        <li style="list-style-type: none;" class="nav-item my-2 my-lg-0">
          <button style="margin-right: 3px;" class="aboutusbuttons" mat-raised-button
            (click)="getCurrentDateEvents()">Today,
            {{currentDate | date:'MMM dd'}}</button>
        </li>
        <li style="list-style-type: none;" class="nav-item my-2 my-lg-0">
          <button style="margin-right: 3px;" class="aboutusbuttons nav-link" routerLink='/about' mat-raised-button>About
            Lebtivity</button>
        </li>
        <li style="list-style-type: none;" class="nav-item my-2 my-lg-0">
          <button style="margin-right: 15px;" class="aboutusbuttons nav-link" routerLink='/about' mat-raised-button>How
            It Works</button>
        </li>
        <li style="list-style-type: none;" class="nav-item my-2 my-lg-0">
          <button class="addeventbutton nav-link" (click)="goToAddEventPage()" mat-raised-button>Add an Event, It's
            Free!</button>
        </li>
        <ul class="nav navbar-nav navbar-right ">
          <!-- <li class=" my-2 my-lg-0">
          <button style="color: white;" (click)="showLogin()" *ngIf="!isLoggedIn" class="nav-link" mat-button>Log
            In</button>
        </li> -->
          <li class=" my-2 my-lg-0">
            <button style="color: white;" (click)="showRegister()" *ngIf="!isLoggedIn" class="nav-link" mat-button>Log
              In / Sign Up</button>
          </li>
          <li *ngIf="isLoggedIn" class="nav-item dropdown my-2 my-lg-0 dropleft">
            <a class="nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <span style="color: white;" class="material-icons menuicon">
                menu
              </span>
              <div class="viewmore">View More</div>
            </a>
            <div style="z-index: 999999999;" class="dropdown-menu text-left" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" routerLink="/main"><i class="fa fa-home"></i>Home</a>
              <a class="dropdown-item" routerLink="/mybookings"><i class="fa fa-calendar"></i>My Calendar</a>
              <a class="dropdown-item" routerLink="/addevent"><i class="fa fa-plus"></i>Create Event</a>
              <a class="dropdown-item" routerLink="/mycreatedevents"><i class="fa fa-clipboard"></i>My Created
                Events</a>
              <a class="dropdown-item" routerLink="/createad"><i class="fa fa-adn"></i>Advertise</a>
              <a class="dropdown-item" routerLink="/favorites"><i class="fa fa-heart"></i>Favorites</a>
              <a class="dropdown-item" routerLink="/myaccount"><i class="fa fa-user"></i>Account Settings</a>
              <a class="dropdown-item" routerLink="/about"><i class="fa fa-info"></i>About Us</a>
              <div class="dropdown-divider"></div>
              <a (click)="logout()" class="dropdown-item" routerLink="/main"><i class="fa fa-sign-out"></i>Log Out</a>
              <a class="dropdown-item" routerLink="/admin/dashboard"><i class="fa fa-cog"></i>Switch To Admin</a>
            </div>
          </li>
        </ul>
        <!-- <ul *ngIf="isLoggedIn" class="nav navbar-nav navbar-right">
        <li class=" my-2 my-lg-0">
          <a class="nav-link" routerLink="/myaccount">
            <img class="userimage" src="{{userImage}}" alt="">
          </a>
        </li>
      </ul> -->
      </div>

    </nav>
  </div>

  <!-- CALENDAR -->
  <div
    *ngIf="!(router.url === '/recycling' || router.url === '/about' || router.url === '/partners' || router.url === '/getintouch' || router.url === '/apidocs' || router.url === '/verify-email')"
    class="fixed" style="background-image: url('/assets/navbarbackground.png')">
    <div *ngIf="!router.url.includes('/admin')">
      <div class="topnav">
        <div style="height: 60px;" class="row">
          <ul id="calendarmonths">
            <!-- YEARS -->
            <li>
              <mat-select disableOptionCentering class="selectYear" style="color: white;" [(value)]='selectedYear'
                (selectionChange)="onYearChange($event)">
                <mat-option class="yearoption" *ngFor="let year of listOfAllYears;" [value]="year">
                  {{year}}
                </mat-option>
              </mat-select>
            </li>

            <!-- MONTHS -->
            <li *ngFor="let month of allMonths;" (click)="onMonthChange(month)">

              <span class="months" [ngClass]="{ 'selectedMonth': month.isSelected }">{{month.name}}</span>
            </li>
          </ul>
        </div>
        <!-- DAYS -->
        <div class="row">
          <div class="col">
            <ul id="calendardays">
              <li *ngFor="let day of listOfDaysOfTheSelectedMonth" (click)="onDayChange(day)"
                [ngClass]="{ 'selectedDay': day.isSelected, 'day': !day.isSelected}">
                <div class="daysnumber">{{day.dayNumber}}</div><br>
                <div class="daysname">{{day.dayName}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- CATEGORIES -->
      <div class="row categorycard topnav">
        <div class="col">
          <ul id="categories">
            <li *ngFor="let category of categories" (click)="selectCategory(category.id, category.name)">
              <span class="category"
                [ngClass]="{ 'selectedcategory': category.id == selectedCategory } ">{{category.name}}</span>

            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- END CALENDER -->

  <!-- MOBILE SEARCH -->
  <div class="mobilesearch">
    <mat-accordion>
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="material-icons">search</i>
          </mat-panel-title>
          <mat-panel-description>
            Click here to search for a specific event
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="row">
          <div class="col d-flex justify-content-center">
            <form [formGroup]="mobileSearchForm">
              <mat-form-field class="row" style="margin: 0 auto;" appearance="outline">
                <mat-label>Name</mat-label>
                <input matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput placeholder="Name"
                  formControlName="name">
              </mat-form-field>
              <!-- <br>
              <mat-form-field class="row" appearance="outline">
                <mat-label>Address</mat-label>
                <input matInput ngx-google-places-autocomplete placeholder="Address" #placesRef="ngx-places"
                  (onAddressChange)="handleAddressChange($event)" formControlName="location" />
              </mat-form-field> -->
              <br>
              <mat-form-field class="row" (click)="picker.open()" appearance="outline">
                <mat-label>Date</mat-label>
                <input placeholder="MM/DD/YYYY" matInput [matDatepicker]="picker" formControlName="date">
                <mat-datepicker touchUi #picker>
                </mat-datepicker>
              </mat-form-field>
              <br>
              <mat-form-field class="row" appearance="outline">
                <mat-select placeholder="Category" enableedOptionCentering formControlName="category">
                  <mat-option *ngFor="let category of categories" [value]="category.id">
                    {{category.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <br>
              <br>
              <button mat-raised-button (click)="mobileSearchEvents()">Search</button>
              <button mat-raised-button style="float:right" (click)="resetSearch()">Refresh</button>
            </form>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

    <!-- ADMIN MENU  -->
    <mat-toolbar *ngIf="router.url.includes('/admin')" class="example-toolbar admintoolbar">
      <img style="height: 100%; margin-left:5px" src='/assets/lebtivityadmin.png' routerLink="/admin/dashboard" />
      <button *ngIf="isLoggedIn" class="menubutton" mat-button [matMenuTriggerFor]="menu"><span class="material-icons">
          menu
        </span>
      </button>
      <mat-menu #menu="matMenu">
        <button routerLink="/admin/dashboard" mat-menu-item>
          <mat-icon>pie_chart</mat-icon>Dashboard
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/pendingevents" mat-menu-item>
          <mat-icon matBadge="{{allPendingEvents}}" matBadgeColor="warn">pending</mat-icon>Pending Events
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/pendingads" mat-menu-item>
          <mat-icon>pending_actions</mat-icon>Pending Ads
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/managepackages" mat-menu-item>
          <mat-icon>view_list</mat-icon>Packages
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/allevents" mat-menu-item>
          <mat-icon>list</mat-icon>All Events
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/sponsoredevents" mat-menu-item>
          <mat-icon>payments</mat-icon>Featured Events
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/ads" mat-menu-item>
          <mat-icon>featured_video</mat-icon>Ads
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/categories" mat-menu-item>
          <mat-icon>category</mat-icon>Categories
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/bulkemail" mat-menu-item>
          <mat-icon>forward_to_inbox</mat-icon>Email Shots
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/usermanagement" mat-menu-item>
          <mat-icon>people_alt</mat-icon>User Management
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/adminmanagement" mat-menu-item>
          <mat-icon>people_outline</mat-icon>Admin Management
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/managepartners" mat-menu-item>
          <mat-icon>groups</mat-icon>Partners
        </button>
        <mat-divider></mat-divider>
        <button routerLink="/admin/partnerscategory" mat-menu-item>
          <mat-icon>swap_vertical_circle</mat-icon>Partners Categories
        </button>
        <mat-divider></mat-divider>
        <button (click)="logout()" mat-menu-item>
          <mat-icon>logout</mat-icon>Log Out
        </button>
        <mat-divider></mat-divider>
        <button (click)="navigateOrRefresh()" mat-menu-item>
          <mat-icon>admin_panel_settings</mat-icon>Switch To User
        </button>
      </mat-menu>
    </mat-toolbar>

    <!-- Login Modal  -->

    <div [style.display]="showLoginModal ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
      aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">Log In</h4>
            <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideLogin()"
              class="material-icons">highlight_off</i>
          </div>
          <div style="display: inline-block;">
            <h6 (click)="hideLogin()" (click)="showRegister()" style="color: blue; cursor: pointer;">Not a user? Sign Up
            </h6>
            <div class="modal-body">
              <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
                <div class="form-group">
                  <label>Email Address</label>
                  <input type="text" formControlName="emailLogin" class="form-control emailinput"
                    [ngClass]="{ 'is-invalid': submitted && l.emailLogin.errors }" />
                  <div *ngIf="submitted && l.emailLogin.errors" class="invalid-feedback">
                    <div *ngIf="l.emailLogin.errors.required">Email is required</div>
                    <div *ngIf="l.emailLogin.errors.email">Email must be a valid email address</div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" formControlName="passwordLogin" class="form-control emailinput"
                    [ngClass]="{ 'is-invalid': submitted && l.passwordLogin.errors }" />
                  <div *ngIf="submitted && l.passwordLogin.errors" class="invalid-feedback">
                    <div *ngIf="l.passwordLogin.errors.required">Password is required</div>
                    <div *ngIf="l.passwordLogin.errors.minlength">Password must be at least 6 characters</div>
                  </div>
                </div>
                <button style="width: 280px;
        height: 48px;
        background:#5d2041 0% 0% no-repeat padding-box;
        opacity: 1;
        cursor: pointer;" type="submit" class="btn btn-primary">Log In
                  <i class="fa fa-spinner fa-spin" *ngIf="loadingLogin"></i></button>
              </form>
              <i (click)="showForgotPassword()" (click)="hideLogin()" class="forgotpassword">Forgot Password?</i>
            </div>
            <div class="separator">Or Login With</div>
            <button class="loginBtn loginBtn--facebook" (click)="logInWithFacebook()">
              Facebook
            </button>
            <button class="loginBtn loginBtn--google" (click)="logInWithGoogle()">
              Google
            </button>
            <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Login Modal -->

    <!-- Forgot Password Modal -->
    <div [style.display]="showForgotPasswordModal ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1"
      role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">Forgot Password</h4>
            <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideForgotPassword()"
              class="material-icons">highlight_off</i>
          </div>
          <div style="display: inline-block;">
            <div class="modal-body">
              <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPassword()">
                <p>A reset password link will be sent to your e-mail, please check it in order to set your new password
                </p>
                <div class="form-group">
                  <label>Email Address</label>
                  <input type="text" formControlName="emailForgotPassword" class="form-control emailinput"
                    [ngClass]="{ 'is-invalid': submitted && fp.emailForgotPassword.errors }" />
                  <div *ngIf="submitted && fp.emailForgotPassword.errors" class="invalid-feedback">
                    <div *ngIf="fp.emailForgotPassword.errors.required">Email is required</div>
                    <div *ngIf="fp.emailForgotPassword.errors.email">Email must be a valid email address</div>
                  </div>
                </div>
                <button style="width: 280px;
        height: 48px;
        background: #5d2041 0% 0% no-repeat padding-box;
        opacity: 1;
        cursor: pointer;" type="submit" class="btn btn-primary">Send Email</button>
              </form>
            </div>
            <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Forgot Password Modal -->


    <!-- Start of Register Modal -->
    <div [style.display]="showRegisterModal ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1"
      role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">Sign Up</h4>
            <i style="transform: scale(2);" data-dismiss="modal" (click)="hideRegister()"
              class="material-icons">highlight_off</i>
          </div>
          <div style="display: inline-block;">
            <h6 (click)="hideRegister()" (click)="showLogin()" style="color: blue; cursor: pointer;">Already a user?
              Sign
              In
            </h6>
            <div class="modal-body">
              <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
                <div style="  display: flex; flex-direction: row;">
                  <div class="form-group">
                    <label>First Name</label>
                    <input type="text" formControlName="firstnameRegister" class="form-control emailinput"
                      [ngClass]="{ 'is-invalid': submitted && f.firstnameRegister.errors }" />
                    <div class="invalid-feedback">
                      <div>First Name is required</div>
                    </div>
                  </div>
                  <div style="margin-left: 5px;" class="form-group">
                    <label>Last Name</label>
                    <input type="text" formControlName="lastnameRegister" class="form-control emailinput"
                      [ngClass]="{ 'is-invalid': submitted && f.lastnameRegister.errors }" />
                    <div class="invalid-feedback">
                      <div>Last Name is required</div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Email Address</label>
                  <input type="text" formControlName="emailRegister" class="form-control emailinput"
                    [ngClass]="{ 'is-invalid': submitted && f.emailRegister.errors }" />
                  <div *ngIf="submitted && f.emailRegister.errors" class="invalid-feedback">
                    <div *ngIf="f.emailRegister.errors.required">Email is required</div>
                    <div *ngIf="f.emailRegister.errors.email">Email must be a valid email address</div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" formControlName="passwordRegister" class="form-control emailinput"
                    [ngClass]="{ 'is-invalid': submitted && f.passwordRegister.errors }" />
                  <div *ngIf="submitted && f.passwordRegister.errors" class="invalid-feedback">
                    <div *ngIf="f.passwordRegister.errors.required">Password is required</div>
                    <div *ngIf="f.passwordRegister.errors.minlength">Password must be at least 6 characters</div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Confirm Password</label>
                  <input type="password" formControlName="confirmpasswordRegister" class="form-control emailinput"
                    [ngClass]="{ 'is-invalid': submitted && f.confirmpasswordRegister.errors }" />
                  <div *ngIf="submitted && f.confirmpasswordRegister.errors" class="invalid-feedback">
                    <div *ngIf="f.confirmpasswordRegister.errors.required">Password is required</div>
                    <div *ngIf="f.confirmpasswordRegister.errors.minlength">Password must be at least 6 characters</div>
                  </div>
                </div>
                <button style="width: 280px;
        height: 48px;
        background: #5d2041 0% 0% no-repeat padding-box;
        opacity: 1;
        cursor: pointer;" type="submit" class="btn btn-primary">
                  <i class="fa fa-spinner fa-spin" *ngIf="loadingRegister"></i>Sign Up</button>
              </form>
            </div>
            <div class="separator">Or Login With</div>
            <button class="loginBtn loginBtn--facebook" (click)="logInWithFacebook()">
              Facebook
            </button>
            <button class="loginBtn loginBtn--google" (click)="logInWithGoogle()">
              Google
            </button>
            <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>
    </div>
<router-outlet></router-outlet>
<footer class="footer-distributed">

  <div style="width: 90%; margin: 0 auto">
    <div class="footer-left">
      <img src="/assets/lebtivitylogo.png">

      <p class="footer-links">
        <a href="/main">Home</a>
        |
        <a href="#">How It Works</a>
        |
        <a href="/about">About</a>
        |
        <a href="/createad">Advertise
        </a>
      </p>

      <p class="footer-company-name">© Lebtivity {{year}}. All rights reserved. </p>
      <div style="margin-top:10px;" class="fb-like" data-href="https://www.facebook.com/Lebtivity" data-width=""
        data-layout="button_count" data-action="like" data-size="small" data-share="true"></div>
    </div>

    <div class="footer-center">
      <div>
        <a href="https://twitter.com/Lebtivity" target="_blank"><i class="fa fa-twitter"></i></a>
        <p><span>Twitter</span></p>
      </div>

      <div>
        <a href="https://www.instagram.com/lebtivity/" target="_blank"><i class="fa fa-instagram"></i></a>
        <p>
          <span>Instagram</span>
        </p>

      </div>
      <div>
        <a href="https://www.facebook.com/Lebtivity" target="_blank"><i class="fa fa-facebook"></i></a>
        <p><span>Facebook</span></p>
      </div>
      <div>
        <a href="mailto:info@lebtivity.com"><i class="fa fa-envelope"></i></a>
        <p><span>info@lebtivity.com</span></p>
      </div>
    </div>
    <div class="footer-right">
      <p class="footer-company-about">
        <span>About Lebtivity</span>
        One place where you could check out and pick which seminars or art exhibitions you'd like to attend, what
        concerts you shouldn't miss, where you could take your kids for some fun time, with whom you could go for a
        fresh nature hike, etc?</p>
      <!-- <div class="footer-icons">
        <a href="https://twitter.com/Lebtivity" target="_blank"><i class="fa fa-twitter"></i></a>
        <a href="https://www.instagram.com/lebtivity/" target="_blank"><i class="fa fa-instagram"></i></a>
        <a href="https://www.linkedin.com/company/lebtivity/" target="_blank"><i class="fa fa-linkedin"></i></a>
        <a href="https://www.facebook.com/Lebtivity" target="_blank"><i class="fa fa-facebook"></i></a>
      </div> -->
    </div>
  </div>

</footer>
